export default "__VITE_ASSET__eb465341__"